module.exports = __webpack_public_path__ + "media/images/official/plan_ticket_icon6_2-36761b2f99315b3740cf28dcebe9ccd9.svg";